<template>
  <!--重置密码-->
  <el-dialog
    title="重置密码"
    :visible.sync="showEditPassword"
    width="30%"
    @close="$emit('update:show', false)"
  >
    <el-form
      v-if="info"
      ref="ruleForm"
      :model="account"
      class="dialog-form"
      :rules="rules"
    >
      <el-form-item label="账号" :label-width="formLabelWidth">{{
        info.account
      }}</el-form-item>
      <el-form-item
        label="新密码"
        :label-width="formLabelWidth"
        prop="psw"
      >
        <el-input
          v-model="account.psw"
          type="password"
          show-password
          autocomplete="off"
        />
        <p style="font-size: 12px;text-align: left;margin: 5px 0 0px;line-height: 1.5;letter-spacing: 1px;">必须包含数字,英文,特殊符号[!@#$%^&*(),], 长度8-20位</p>
      </el-form-item>
      <el-form-item
        label="确认新密码"
        :label-width="formLabelWidth"
        prop="checkPsw"
      >
        <el-input
          v-model="account.checkPsw"
          type="password"
          show-password
          autocomplete="off"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:show', false)">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit('ruleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateAdminAccount } from '@/api/adminAccount'
export default {
  props: {
    accountInfo: {
      type: Object,
      default() {
        return null
      }
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    // var validatePass = (rule, value, callback) => {
    //   const reg = /^(?![A-Za-z0-9]+$)(?![a-z0-9_!@#$%^&*()+.]+$)(?![A-Za-z_!@#$%^&*()+.]+$)(?![A-Z0-9_!@#$%^&*()+.]+$)[a-zA-Z0-9_!@#$%^&*()+.]{8,20}$/
    //   if (!reg.test(value)) {
    //     callback(new Error('必须包含数字,英文,特殊符号!@#$%^&*(),长8-20'))
    //   } else {
    //     if (this.account.checkPsw !== '') {
    //       this.$refs.ruleForm.validateField('checkPsw')
    //     }
    //     callback()
    //   }
    // }
    var validatePass = (rule, value, callback) => {
      if (!/[0-9]+/.test(value)) {
        return callback(new Error('密码必须包含数字或字母'))
      }
      if (!/[A-Za-z]+/.test(value)) {
        return callback(new Error('密码必须包含数字或字母'))
      }
      if (!/[!@#$%^&*(),]+/.test(value)) {
        return callback(new Error('密码必须包含特殊符号!@#$%^&*(),'))
      }
      if (value.length < 6) {
        callback(new Error('密码不能少于6位'))
      } else if (value.length > 20) {
        callback(new Error('密码不能超过20位'))
      } else {
        if (this.account.checkPsw !== '') {
          this.$refs.ruleForm.validateField('checkPsw')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.account.psw) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      showEditPassword: this.show, // 打开密码修改
      account: {
        // 当前选中账号信息
        psw: '',
        checkPsw: ''
      },
      info: this.accountInfo,
      formLabelWidth: '100',
      rules: {
        psw: [{ validator: validatePass, trigger: 'blur' }],
        checkPsw: [{ validator: validatePass2, trigger: 'blur' }]
      },
      loading: false
    }
  },

  watch: {
    show(n) {
      this.account.psw = ''
      this.account.checkPsw = ''
      this.showEditPassword = this.show
    },
    accountInfo() {
      this.info = this.accountInfo
      this.account.id = this.accountInfo.id
    }
  },

  methods: {
    onSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true
          updateAdminAccount(this.account.id, {
            password: this.account.psw,
            password_confirmation: this.account.checkPsw
          }).then((response) => {
            // 关闭弹层
            this.$emit('update:show', false)
            this.$message({
              message: '更新账号信息成功',
              type: 'success',
              duration: 3 * 1000
            })
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/dialog-form.scss";
</style>
